import { Block } from '../../models/block';

class HeaderDetailsBlock extends Block {
    getStyles = () => this.styles;
}
 
export default HeaderDetailsBlock;
